<style>
th {
  font-weight: bold;
  font-size: 10px;
}
td {
  font-size: 10px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card>
      <b-card-header header-tag="header" class="p-1" role="tab">Recurrencias</b-card-header>

      <div style="font-size:12px">
        Al aceptar esta solicitud de adhesión SE EXTRAERÁN FONDOS DE SU CUENTA en forma periódica, los que serán remitidos a quien mandó la orden de extracción.
        <br />Tenga en cuenta que NUNCA es necesario dar una autorización para RECIBIR pagos electrónicos
      </div>

      <div v-if="this.model.recurrencesLenght == 0" class="text-center">
        <div>No se encontraron registros</div>
        <img src="/img/ic_no_resultado.png" style="width: 200px;" />
      </div>
      <div v-else>
        <div style="width: 100%; overflow-x:auto;">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="text-center">
                  <strong>Acciones</strong>
                </th>
                <th scope="col" class="text-center">
                  <strong>Id Recurrencia</strong>
                </th>
                <th scope="col">
                  <strong>CUIT Origen</strong>
                </th>
                <th scope="col">
                  <strong>Estado</strong>
                </th>
                <th scope="col">
                  <strong>Detalle</strong>
                </th>
                <th scope="col">
                  <strong>Concepto</strong>
                </th>
                <th scope="col">
                  <strong>Prestación</strong>
                </th>
                <th scope="col">
                  <strong>Referencia</strong>
                </th>
                <th scope="col">
                  <strong>Fecha Recepción</strong>
                </th>
                <th scope="col">
                  <strong>Fecha Aceptación/Rechazo</strong>
                </th>
                <th scope="col">
                  <strong>Fecha Baja</strong>
                </th>
                <th scope="col">
                  <strong>Fecha Reactivación</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in this.model.recurrences"
                v-bind:key="item.EntityID"
                style="border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
              >
                <td class="text-center align-middle">
                  <div style="display: flex; justify-content: center; gap: 8px; flex-wrap: nowrap;">
                    <template v-if="item.AllowAccept">
                      <button
                        type="button"
                        @click="ConfirmarRecurrencia(item.EntityID, true)"
                        class="btn btn-primary"
                        style="background-color:green"
                      >Aceptar</button>
                    </template>
                    <template v-if="item.AllowReject">
                      <button
                        type="button"
                        @click="ConfirmarRecurrencia(item.EntityID, false)"
                        class="btn btn-primary"
                        style="background-color:red"
                      >Rechazar</button>
                    </template>

                    <template v-if="item.AllowDrop">
                      <button
                        type="button"
                        @click="AdherirRecurrencia(item.EntityID, false, false)"
                        class="btn btn-primary"
                        style="background-color:blue"
                      >Baja Temporal</button>
                      <button
                        type="button"
                        @click="AdherirRecurrencia(item.EntityID, false, true)"
                        class="btn btn-primary"
                        style="background-color:red"
                      >Baja Definitiva</button>
                    </template>

                    <template v-if="item.AllowActivation">
                      <button
                        type="button"
                        @click="AdherirRecurrencia(item.EntityID, true, false)"
                        class="btn btn-primary"
                        style="background-color:green"
                      >Activar</button>
                    </template>
                  </div>
                </td>
                <td class="text-center">{{item.RecurrenceId}}</td>
                <td class="text-center">{{item.SellerCuit}}</td>
                <td class="text-center">{{item.AuthorizationStatusDescription}}</td>
                <td class="text-center">{{item.DebinDetail}}</td>
                <td class="text-center">{{item.DebinConcept}}</td>
                <td class="text-center">{{item.DebinBenefit}}</td>
                <td class="text-center">{{item.DebinReference}}</td>
                <td class="text-center">{{item.FormattedCreationDatetime}}</td>
                <td class="text-center">{{item.FormattedAutorizationRejectDatetime}}</td>
                <td class="text-center">{{item.FormattedDropDatetime}}</td>
                <td class="text-center">{{item.FormattedReactivationDatetime}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <b-card-body></b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  data() {
    return {
      model: {
        recurrences: [],
        recurrencesLenght: 0
      }
    };
  },
  methods: {
    GetRecurrencesForUser() {
      let context = this;

      axiosHelpers.axiosGet(
        "Recurrence/GetRecurrencesForUser",
        {},
        context,
        function(response) {
          context.model.recurrences = response.ResponseVM.Items;
          context.model.recurrencesLenght = context.model.recurrences.length;
        }
      );
    },
    ConfirmarRecurrencia(recurrenceId, accept) {
      let context = this;

      axiosHelpers.axiosPost(
        "Recurrence/ConfirmarRecurrencia",
        { RecurrenceId: recurrenceId, Authorized: accept },
        context,
        function(response) {
          if (response.ResponseVM.Success) {
            context.GetRecurrencesForUser();
          }
        }
      );
    },
    AdherirRecurrencia(recurrenceId, activeRecurrence, isDefinitiveDrop) {
      let context = this;

      axiosHelpers.axiosPost(
        "Recurrence/AdherirRecurrencia",
        {
          RecurrenceId: recurrenceId,
          ActiveRecurrence: activeRecurrence,
          IsDefinitiveDrop: isDefinitiveDrop
        },
        context,
        function(response) {
          if (response.ResponseVM.Success) {
            context.GetRecurrencesForUser();
          }
        }
      );
    }
  },
  mounted() {
    this.GetRecurrencesForUser();
  }
};
</script>
